module.exports = __webpack_public_path__ + "static/media/why-1.dfd92ea8.svg";